import React from 'react';

const showHideLinks = (linksId, e) => {
  const links = document.getElementById(linksId);
  const icone = e.currentTarget.querySelector('i');

  if (links.classList.contains('show')) {
    links.classList.remove('show');
    icone.className = 'ic-adicionar-circulo';
  } else {
    links.classList.add('show');
    icone.className = 'ic-diminuir-circulo';
  }
};

const FooterLinks = () => {
  return (
    <div className='footer-links-container'>
      <div className='footer-links'>
        <div className='footer-col'>
          <h5 onClick={(e) => showHideLinks('links-fale-conosco', e)}>
            Fale Conosco
            <button
              id='btn-fale-conosco'
              className='btn-txt so-icone btn-mostrar'>
              <i className='ic-adicionar-circulo'></i>
            </button>
          </h5>

          <div id='links-fale-conosco' className='col-links'>
            <a
              className='txt-link'
              href='https://faleconosco.correios.com.br/faleconosco/app/index.php'>
              <i className='ic-monitor'></i>
              Registro de manifestações
            </a>
            <a
              className='txt-link'
              href='https://www.correios.com.br/falecomoscorreios/central-de-atendimento'>
              <i className='ic-telefone'></i>
              Central de atendimento
            </a>
            <a
              className='txt-link'
              href='https://faleconosco.correios.com.br/faleconosco/app/cadastro/contrate/index.php'>
              <i className='ic-negocios'></i>
              Soluções para o seu negócio
            </a>
            <a
              className='txt-link'
              href='https://faleconosco.correios.com.br/faleconosco/app/cadastro/suporte/index.php'>
              <i className='ic-headset'></i>
              Suporte ao cliente de contrato
            </a>
            <a
              className='txt-link'
              href='https://www.correios.com.br/falecomoscorreios/ouvidoria'>
              <i className='ic-ouvidoria'></i>
              Ouvidoria
            </a>
            <a
              className='txt-link'
              href='https://www.correios.com.br/falecomoscorreios/canais-de-denuncia'>
              <i className='ic-denuncia'></i>
              Denúncia
            </a>
            <a className='txt-link' href='https://c.correios.com.br/seguranca'>
              <i className='ic-escudo-visto'></i>
              Segurança
            </a>
          </div>
        </div>

        <div className='footer-col'>
          <h5 onClick={(e) => showHideLinks('links-sobre-correios', e)}>
            Sobre os Correios
            <button
              id='btn-fale-conosco'
              className='btn-txt so-icone btn-mostrar'>
              <i className='ic-adicionar-circulo'></i>
            </button>
          </h5>

          <div id='links-sobre-correios' className='col-links'>
            <a
              className='txt-link'
              href='https://www.correios.com.br/acesso-a-informacao/institucional/identidade-corporativa'>
              <i className='ic-identidade'></i>
              Identidade corporativa
            </a>
            <a
              className='txt-link'
              href='https://www.correios.com.br/educacao-e-cultura'>
              <i className='ic-educacao'></i>
              Educação e cultura
            </a>
            <a
              className='txt-link'
              href='https://www.correios.com.br/acesso-a-informacao/servidores/arquivos/codigo-de-conduta-etica-integridade'>
              <i className='ic-livro'></i>
              Código de Conduta Ética e Integridade
            </a>
            <a
              className='txt-link'
              href='https://www.correios.com.br/acesso-a-informacao/transparencia-e-governanca/transparencia-e-prestacao-de-contas/transparencia-e-prestacao-de-contas'>
              <i className='ic-lupa'></i>
              Transparência e prestação de contas
            </a>
            <a
              className='txt-link'
              href='https://www.correios.com.br/acesso-a-informacao/transparencia-e-governanca/sustentabilidade/sustentabilidade'>
              <i className='ic-planta'></i>
              Sustentabilidade
            </a>
            <a
              className='txt-link'
              href='https://www.correios.com.br/falecomoscorreios/politica-de-privacidade-e-cookies'>
              <i className='ic-denuncia'></i>
              Política de privacidade e cookies
            </a>
            <a
              className='txt-link'
              href='https://sgdados.correios.com.br/app/index.php'>
              <i className='ic-usuario-cadeado'></i>
              Minha privacidade nos Correios
            </a>
          </div>
        </div>

        <div className='footer-col'>
          <h5 onClick={(e) => showHideLinks('links-info', e)}>
            Informações
            <button
              id='btn-fale-conosco'
              className='btn-txt so-icone btn-mostrar'>
              <i className='ic-adicionar-circulo'></i>
            </button>
          </h5>
          <div id='links-info' className='col-links'>
            <a
              className='txt-link'
              href='https://www.correios.com.br/educacao-e-cultura/filatelia/compre-seu-selo-aqui/compre-seu-selo-aqui'>
              <i className='ic-carrinho'></i>
              Loja online dos Correios
            </a>
            <a className='txt-link' href='https://www.postalis.org.br/'>
              <img className='ic-traco' src='/images/icones/ic-postalis.svg' />
              Postalis
            </a>
            <a className='txt-link' href='https://www.postalsaude.com.br/'>
              <img
                className='ic-traco'
                src='/images/icones/ic-postal-saude.svg'
              />
              Postal saúde
            </a>
            <a className='txt-link' href='https://www.gov.br/mcom/pt-br'>
              <img className='ic-traco' src='/images/icones/ic-patria.svg' />
              Ministério das Comunicações
            </a>
            <a
              className='txt-link'
              href='https://www.correios.com.br/acesso-a-informacao/acoes-e-programas/carta-de-servicos-aos-usuarios'>
              <i className='ic-carta'></i>
              Cartas de Serviço ao Usuário
            </a>
            <a
              className='txt-link'
              href='https://www.correios.com.br/falecomoscorreios/sei-protocolo-eletronico'>
              <img className='ic-traco' src='/images/icones/ic-sei.svg' />
              SEI - Protocolo Eletrônico
            </a>
            <a
              className='txt-link'
              href='https://www.correios.com.br/acesso-a-informacao/'>
              <i className='ic-duvida'></i>
              Acesso a informação
            </a>
          </div>
        </div>

        <div className='footer-col'>
          <h5>Siga os Correios</h5>
          <div className='icones-row'>
            <a
              className='txt-link so-icone'
              href='https://www.youtube.com/@correiosoficial'>
              <img className='ic-traco' src='/images/icones/ic-youtube.svg' />
            </a>
            <a
              className='txt-link so-icone'
              href='https://www.instagram.com/correiosoficial/'>
              <img className='ic-traco' src='/images/icones/ic-instagram.svg' />
            </a>
            <a
              className='txt-link so-icone'
              href='https://www.facebook.com/correios/?locale=pt_BR'>
              <img className='ic-traco' src='/images/icones/ic-facebook.svg' />
            </a>
            <a
              className='txt-link so-icone'
              href='https://br.linkedin.com/company/correios'>
              <img className='ic-traco' src='/images/icones/ic-linkedin.svg' />
            </a>
            <a
              className='txt-link so-icone'
              href='https://www.tiktok.com/@correiosoficialbr'>
              <img className='ic-traco' src='/images/icones/ic-tiktok.svg' />
            </a>
            <a
              className='txt-link so-icone'
              href='https://www.flickr.com/photos/correiosoficial/'>
              <img className='ic-traco' src='/images/icones/ic-flikr.svg' />
            </a>
            <a
              className='txt-link so-icone'
              href='https://br.pinterest.com/correios/'>
              <img className='ic-traco' src='/images/icones/ic-pinterest.svg' />
            </a>
          </div>

          <h5>Aplicativos Correios</h5>
          <div className='icones-row'>
            <a
              className='txt-link so-icone'
              href='https://apps.apple.com/br/developer/ect-empresa-brasileira-de-correios-e-telegrafos/id866480129'>
              <img className='ic-traco' src='/images/icones/ic-apple.svg' />
            </a>
            <a
              className='txt-link so-icone'
              href='https://play.google.com/store/apps/developer?id=Empresa+Brasileira+de+Correios+e+Telegrafos&amp;amp;hl=pt'>
              <img className='ic-traco' src='/images/icones/ic-android.svg' />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterLinks;
